import React from "react";
import { useNavigate } from "react-router-dom";
import "./clientTheme.css";
import "./StoreRelationRow.css";

function StarIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2l2.9 6.9 7.1.6-5.4 4.7 1.7 7-6.3-3.8-6.3 3.8 1.7-7L2 9.5l7.1-.6z" />
    </svg>
  );
}

export default function StoreRelationRow({ store, actionLabel, onAction, actionBusy }) {
  const navigate = useNavigate();
  const city = store.city;
  const rating = Number(store.rating ?? 0);

  return (
    <div className="store-relation-row">
      <button
        type="button"
        className="store-relation-row-main"
        onClick={() => navigate(`/products?storeId=${store.storeId}`)}
      >
        {store.logoUrl ? (
          <img src={store.logoUrl} alt="" className="store-relation-row-logo" />
        ) : (
          <div className="store-relation-row-logo store-relation-row-logo-placeholder">
            {store.storeName.charAt(0)}
          </div>
        )}

        <div className="store-relation-row-info">
          <span className="store-relation-row-name">{store.storeName}</span>
          <span className="store-relation-row-meta">
            {city ? `${city} · ` : ""}
            <StarIcon />
            {rating.toFixed(1)}
          </span>
        </div>
      </button>

      <button
        type="button"
        className="store-relation-row-action"
        onClick={() => onAction(store.storeId)}
        disabled={actionBusy}
      >
        {actionLabel}
      </button>
    </div>
  );
}
